/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import {
  createMockEndpoint,
  HTTP_STATUS_PRECONDITION_FAILED_ERROR,
  MockDataEndpointMethod,
  mockErrorResponse,
} from '@gh/core-data';
import { MessageSeverity, severityToString } from '@gh/core-messages';

export interface MockDataBusinessErrorEndpointConfig {
  url: string;
  id: string;
  method?: MockDataEndpointMethod;
  params?: Hash<any>;
  severity?: MessageSeverity;
}

export const mockBusinessError = (config: MockDataBusinessErrorEndpointConfig) => {
  const { url, method } = config;
  return createMockEndpoint(
    url,
    [method || 'get'],
    businessErrorMockDataProcessor(config));
};

const businessErrorMockDataProcessor = (config: MockDataBusinessErrorEndpointConfig) => () => {
  const { url, id, params, severity } = config;
  return mockErrorResponse(url, HTTP_STATUS_PRECONDITION_FAILED_ERROR, 'Unprocessable Entity', {
    messageIdentifier: id,
    parameters: params,
    severity: severityToString(severity || MessageSeverity.Error),
  });
};
